<template>
  <section class="bm-sku-spec">
    <header class="bm-sku-spec__head">
      <div class="bm-sku-spec__crumb">
        <button @click="$emit('back')">‹ 返回</button>
        <span>
          云库工作台　›　批量修改　›
          <strong>SKU规格名称/备注</strong>
        </span>
        <a>帮助教程</a>
      </div>
      <h1>批量修改SKU规格名称/备注</h1>
      <nav>
        <button
          class="mode-range"
          :class="{ active: mode === 'range' }"
          @click="switchMode('range')"
        >
          按范围修改
        </button>
        <button
          class="mode-goods"
          :class="{ active: mode === 'goods' }"
          @click="switchMode('goods')"
        >
          按商品修改
        </button>
      </nav>
    </header>
    <main class="bm-sku-spec__body">
      <section v-if="mode === 'range'" class="bm-sku-spec__filter">
        <div v-for="field in fields" :key="field.key" class="bm-sku-spec__field">
          <label>{{ field.label }}</label>
          <el-select
            v-if="field.select"
            v-model="filterValues[field.key]"
            class="bm-sku-spec__filter-select"
          >
            <el-option label="全部" value="" />
            <el-option
              v-for="o in optionsFor(field.key)"
              :key="o.value"
              :label="o.label"
              :value="o.value"
            />
          </el-select>
          <div v-else-if="field.range" class="bm-sku-spec__date-range">
            <input
              v-model="addTime[0]"
              type="date"
              class="bm-sku-spec__date-input"
            />
            <span>—</span>
            <input
              v-model="addTime[1]"
              type="date"
              class="bm-sku-spec__date-input"
            />
          </div>
          <el-select
            v-else-if="
              field.key === 'group_id' || field.key === 'child_group_id'
            "
            v-model="filterValues[field.key]"
            class="bm-sku-spec__filter-select"
            @change="field.key === 'group_id' && onGroupChange()"
          >
            <el-option label="全部" value="" />
            <el-option
              v-for="o in optionsFor(field.key)"
              :key="o.value"
              :label="o.label"
              :value="o.value"
            />
          </el-select>
          <input
            v-else
            v-model="filterValues[field.key]"
            :placeholder="field.placeholder"
          />
        </div>
        <footer>
          <div>
            <button @click="previewBatch">查询</button>
            <button class="plain" @click="reset">重置</button>
          </div>
        </footer>
      </section>
      <section v-else class="bm-sku-spec__picked">
        <button @click="openSelector">选择商品</button>
        <span>{{
          selected.length
            ? "已选择 " + selected.length + " 个商品"
            : "请先选择需要修改的商品"
        }}</span>
      </section>
      <!-- 修改范围：合并修改对象、规格选择、SKU筛选 -->
      <section class="bm-sku-spec__methods">
        <header>
          <i></i>
          修改范围
        </header>
        <article>
          <!-- 1. 修改对象 -->
          <div class="scope-item-group">
            <label class="scope-title">修改对象：</label>
            <el-checkbox
              :value="form.modifyTarget === 'spec_name'"
              @change="handleModifyTargetChange('spec_name')"
              class="bm-sku-spec__method-name"
            >
              仅修改规格名称
            </el-checkbox>
            <el-checkbox
              :value="form.modifyTarget === 'remark'"
              @change="handleModifyTargetChange('remark')"
              class="bm-sku-spec__method-name"
            >
              仅修改备注
            </el-checkbox>
          </div>
          <!-- <div v-if="form.modifyTarget === 'remark'" style="margin-top: 8px; color: #999; font-size: 12px;">
            <small>说明：批量修改备注，若商品不支持该备注类型，系统会自动跳过处理</small>
          </div> -->
        </article>

        <article v-if="form.modifyTarget === 'spec_name'">
          <!-- 2. 规格选择 (仅修改规格名称时显示) -->
          <div class="scope-item-group">
            <label class="scope-title">规格选择：</label>
            <el-checkbox
              :value="form.specSelection === 'all_spec'"
              @change="handleSpecSelectionChange('all_spec')"
              class="bm-sku-spec__method-name"
            >
              修改所有规格
            </el-checkbox>
            <el-checkbox
              :value="form.specSelection === 'spec_1'"
              @change="handleSpecSelectionChange('spec_1')"
              class="bm-sku-spec__method-name"
            >
              修改规格1
            </el-checkbox>
            <el-checkbox
              :value="form.specSelection === 'spec_2'"
              @change="handleSpecSelectionChange('spec_2')"
              class="bm-sku-spec__method-name"
            >
              修改规格2
            </el-checkbox>
          </div>
        </article>

        <article>
          <!-- 3. SKU筛选 -->
          <div class="sku-scope-row">
            <div class="scope-item-group">
              <label class="scope-title">SKU筛选：</label>
              <el-checkbox
                :value="form.specMatchEnabled === false"
                @change="toggleSpecMatch(false, $event)"
              >
                所有SKU
              </el-checkbox>
              <el-checkbox
                :value="form.specMatchEnabled === true"
                @change="toggleSpecMatch(true, $event)"
              >
                符合条件的SKU
              </el-checkbox>
            </div>
            <div class="sku-scope-config">
              <el-select
                v-model="form.specMatchField"
                class="bm-sku-spec__select"
                size="mini"
                :disabled="!form.specMatchEnabled"
              >
                <template v-if="form.modifyTarget === 'spec_name'">
                  <el-option label="SKU规格名称包含关键字" value="spec_name:contains" />
                  <el-option label="SKU规格名称不包含关键字" value="spec_name:not_contains" />
                  <el-option label="SKU规格名称精确为" value="spec_name:exact" />
                </template>
                <template v-else>
                  <el-option label="SKU备注包含关键字" value="remark:contains" />
                  <el-option label="SKU备注不包含关键字" value="remark:not_contains" />
                  <el-option label="SKU备注精确为" value="remark:exact" />
                </template>
              </el-select>
              <el-input
                v-model="form.specMatchKeywords"
                size="mini"
                :disabled="!form.specMatchEnabled"
                maxlength="1000"
                placeholder="多个关键字用逗号隔开，最多输入100个"
              />
              <span v-if="specMatchKeywordCount" class="sku-keyword-count">{{ specMatchKeywordCount }}/100</span>
            </div>
          </div>
        </article>

        <article v-if="form.modifyTarget === 'remark'">
          <!-- 4. 备注特有选项 -->
          <div class="scope-item-group">
            <label class="scope-title">备注截断：</label>
            <el-checkbox
              :value="form.remarkAutoTruncate === true"
              :disabled="form.modifyTarget === 'remark'"
              @change="toggleRemarkTruncate(true, $event)"
            >
              如果修改后的备注超过 {{ form.remarkMaxLength }} 个字符，自动截断，截断方向：
            </el-checkbox>
            <el-select
              size="mini"
              v-model="form.remarkTruncateDirection"
              class="bm-sku-spec__select"
              :disabled="!form.remarkAutoTruncate"
              style="width: 240px;"
            >
              <el-option label="从前面删除（保留后面）" value="from_start" />
              <el-option label="从后面删除（保留前面）" value="from_end" />
            </el-select>
          </div>
        </article>
      </section>

      <!-- 修改内容 -->
      <section class="bm-sku-spec__methods">
        <header>
          <p></p>
          修改内容
        </header>
        <article v-for="(method, index) in availableMethods" :key="method.value">
          <el-checkbox
            v-model="method.on"
            @change="handleMethodChange(index)"
            class="bm-sku-spec__method-name"
          >
            方式{{ index + 1 }}：{{ method.label }}
            <el-tooltip v-if="method.tooltip" :content="method.tooltip" placement="top">
              <i class="el-icon-question" style="margin-left: 5px; color: #909399; cursor: help;"></i>
            </el-tooltip>
          </el-checkbox>
          <div class="bm-sku-spec__method-content">
            <!-- 方式1：增加备注（仅备注） -->
            <template v-if="method.value === 'add_remark'">
              <div class="bm-sku-spec__single-input">
                <input
                  v-model="form.newRemark"
                  maxlength="50"
                  placeholder="请输入备注内容"
                />
                <small>{{ form.newRemark.length }}/50</small>
              </div>
              <div class="bm-sku-spec__radio-group">
                <label>已有备注内容：</label>
                <label class="bm-sku-spec__radio-label">
                  <input
                    v-model="form.existingRemarkAction"
                    value="skip"
                    type="radio"
                    name="existingRemarkAction"
                    class="bm-sku-spec__radio"
                  />
                  <span>跳过不修改</span>
                </label>
                <label class="bm-sku-spec__radio-label">
                  <input
                    v-model="form.existingRemarkAction"
                    value="use_new"
                    type="radio"
                    name="existingRemarkAction"
                    class="bm-sku-spec__radio"
                  />
                  <span>使用新备注</span>
                </label>
              </div>
            </template>

            <!-- 删除关键字 -->
            <template v-else-if="method.value === 'delete_keyword'">
              <div class="bm-sku-spec__multi-input">
                <textarea
                  v-model="form.deleteKeywords"
                  maxlength="1000"
                  placeholder="请输入需要删除的关键字，多个关键字用逗号分隔"
                ></textarea>
                <small>{{ form.deleteKeywords.length }}/1000</small>
              </div>
            </template>

            <!-- 关键字替换 -->
            <template v-else-if="method.value === 'replace_keyword'">
              <div
                v-for="(rule, replaceIndex) in form.replaceRules"
                :key="replaceIndex"
                class="bm-sku-spec__replace"
              >
                <span>关键字:</span>
                <input v-model="rule.search" placeholder="请输入关键字" />
                <span>替换为</span>
                <input v-model="rule.replace" placeholder="替换后内容" />
                <button @click="addReplaceRule">＋ 添加</button>
                <button
                  v-if="replaceIndex"
                  class="danger"
                  @click="removeReplaceRule(replaceIndex)"
                >
                  删除
                </button>
              </div>
            </template>

            <!-- 精准替换 -->
            <template v-else-if="method.value === 'standard_replace'">
              <div
                v-for="(rule, replaceIndex) in form.standardReplaceRules"
                :key="replaceIndex"
                class="bm-sku-spec__replace"
              >
                <span>关键字:</span>
                <input v-model="rule.search" placeholder="请输入关键字" />
                <span>替换为</span>
                <input v-model="rule.replace" placeholder="替换后内容" />
                <button @click="addStandardReplaceRule">＋ 添加</button>
                <button
                  v-if="replaceIndex"
                  class="danger"
                  @click="removeStandardReplaceRule(replaceIndex)"
                >
                  删除
                </button>
              </div>
            </template>

            <!-- 增加前后缀 -->
            <template v-else-if="method.value === 'add_prefix_suffix'">
              <div class="bm-sku-spec__inline">
                <span>增加前缀内容:</span>
                <input v-model="form.prefix" placeholder="请输入前缀" />
                <span>增加后缀:</span>
                <input v-model="form.suffix" placeholder="请输入后缀" />
              </div>
            </template>

          </div>
        </article>
      </section>

      <section v-if="preview" class="bm-sku-spec__preview">
        <header>
          预览：共
          <b>{{
            preview.product_count || preview.total || previewGoods.length || 0
          }}</b>
          个商品，跳过
          <b>{{
            preview.skipped_product_count ||
            preview.skipped_product_count_total ||
            0
          }}</b>
          个商品，失败
          <b>{{ preview.failed_product_count || preview.failed_count || 0 }}</b>
          个商品
        </header>
        <table>
          <thead>
            <tr>
              <th>商品信息</th>
              <th>SKU信息</th>
              <th>状态</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in previewGoods"
              :key="String(item.product_id || index)"
              :class="{
                'is-excluded': excludedProductIds.includes(
                  String(item.product_id)
                ),
              }"
            >
              <td>
                <el-image
                  class="bm-sku-spec__image"
                  :src="imageOf(item)"
                  fit="cover"
                  :preview-src-list="[imageOf(item)]"
                />
                <div>
                  <p>{{ item.title || item.product_title }}</p>
                  <div class="preview-meta">
                    <small>商品ID：{{ item.product_id }}</small>
                    <small
                      >来源ID：{{ item.source_product_id || "无数据" }}</small
                    >
                    <small>数据源：{{ sourceLabel(item.source_web) }}</small>
                  </div>
                </div>
              </td>
              <!-- <td class="price-cell">
                <div>
                  修改前价格：{{
                    previewPrice(item, 'old_price')
                  }}
                </div>
                <div>
                  修改后价格：{{
                    previewPrice(item, 'new_price')
                  }}
                </div>
              </td> -->
              <td>
                <details class="bm-sku-spec__sku-list" :open="item._skuOpen">
                  <summary @click.prevent="loadSku(item)">
                    {{ item._skuLoading ? "加载中" : "SKU明细" }}
                  </summary>
                  <table>
                    <thead>
                      <tr>
                        <th>规格</th>
                        <th>原值</th>
                        <th>新值</th>
                        <th>状态</th>
                        <th>错误信息</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="sku in skuRows(item)"
                        :key="String(sku.sku_id)"
                        :class="{
                          'sku-matched-row':
                            sku.matched === true && !sku.error_msg,
                          'sku-unmatched-row': sku.matched === false,
                          'sku-failed-row':
                            sku.matched === true && sku.error_msg,
                        }"
                      >
                        <td>
                          {{ sku.sku_spec_text || sku.spec_text || "默认规格" }}
                        </td>
                        <td>
                          {{ (sku.old_value != null ? sku.old_value : "无数据").replace(/\|\|\|/g, ', ') }}
                        </td>
                        <td>
                          <span v-if="sku.matched">
                            {{ (sku.new_value || '').replace(/\|\|\|/g, ', ') }}
                            <span v-if="sku.truncated" class="truncated-badge"
                              >已截断</span
                            >
                          </span>
                          <span v-else>不修改</span>
                        </td>
                        <td>
                          {{
                            sku.status_text ||
                            (sku.matched ? "命中，已计算" : "未命中，不修改")
                          }}
                        </td>
                        <!-- <td>{{ sku.status_text || sku.status || '—' }}</td> -->
                        <td>
                          {{
                            sku.error_msg === "PRODUCT_PRICE_GUARD_BLOCKED"
                              ? "该商品存在 SKU 不符合误操作防范条件，全部 SKU 未修改"
                              : sku.error_msg || "—"
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <p v-if="!skuRows(item).length">暂无SKU明细</p>
                  <p v-if="item._skuError" class="sku-error">
                    {{ item._skuError }}
                  </p>
                </details>
              </td>
              <td>
                {{ item.status_text || item.status || "待处理" }}
                <span v-if="item.error_msg">{{ item.error_msg }}</span>
              </td>
              <td class="action-cell">
                <button @click="toggleExclude(item)">
                  {{
                    excludedProductIds.includes(String(item.product_id))
                      ? "恢复修改"
                      : "排除修改"
                  }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <footer class="bm-sku-spec__pagination">
          <button
            :disabled="previewPage.page <= 1"
            @click="previewBatchPage(previewPage.page - 1)"
          >
            上一页
          </button>
          <span>第 {{ previewPage.page }} / {{ pageCount }} 页</span>
          <button
            :disabled="previewPage.page >= pageCount"
            @click="previewBatchPage(previewPage.page + 1)"
          >
            下一页
          </button>
          <select
            v-model.number="previewPage.limit"
            @change="previewBatchPage(1)"
          >
            <option :value="10">10条/页</option>
            <option :value="20">20条/页</option>
            <option :value="50">50条/页</option>
          </select>
        </footer>
      </section>
      <p
        v-if="preview && preview.warnings && preview.warnings.length"
        class="bm-sku-spec__warnings"
      >
        {{
          preview.warnings
            .map((item) => item.message + "（商品ID：" + item.product_id + "）")
            .join("；")
        }}
      </p>
    </main>
    <footer class="bm-sku-spec__bottom">
      <button class="preview" :disabled="previewLoading" @click="previewBatch">
        {{ previewLoading ? "预览中" : "修改内容预览" }}
      </button>
      <button
        class="start"
        :disabled="!canCreate || submitting"
        @click="createBatch"
        title="点击预览检查无误后，再点击开始批量修改"
      >
        {{ submitting ? "提交中" : "开始批量修改" }}
      </button>
    </footer>
    <div v-if="selecting" class="bm-sku-spec__mask">
      <div class="bm-sku-spec__select-modal">
        <header>
          <strong>选择修改商品</strong>
          <button @click="selecting = false">×</button>
        </header>
        <nav>
          <button
            :class="{ active: selectorTab === 'all' }"
            @click="switchSelectorTab('all')"
          >
            选择商品
          </button>
          <button
            :class="{ active: selectorTab === 'selected' }"
            @click="switchSelectorTab('selected')"
          >
            已选择
          </button>
        </nav>
        <div class="bm-sku-spec__selector-toolbar">
          <div class="bm-sku-spec__select-filter">
            <el-select
              v-model="selectorFilters.group_id"
              popper-class="bm-sku-spec__select-popper"
              class="bm-sku-spec__group-select"
              @change="loadSelectorGroups"
            >
              <el-option label="全部分组" value="" />
              <el-option
                v-for="g in groupList"
                :key="g.id"
                :label="g.name || g.group_name"
                :value="g.id"
              />
            </el-select>
            <el-select
              v-model="selectorFilters.child_group_id"
              popper-class="bm-sku-spec__select-popper"
              class="bm-sku-spec__group-select"
              @change="loadGoods(1)"
            >
              <el-option label="全部子分组" value="" />
              <el-option
                v-for="g in selectorChildGroups"
                :key="g.id"
                :label="g.name || g.group_name"
                :value="g.id"
              />
            </el-select>
            <input
              v-model="selectorFilters.source_product_id"
              placeholder="来源ID"
            />
            <input v-model="selectorFilters.keyword" placeholder="商品标题" />
            <button @click="loadGoods(1)">查询</button>
          </div>
          <div class="bm-sku-spec__selector-pagination">
            <button
              :disabled="selectorPage.page <= 1"
              @click="loadGoods(selectorPage.page - 1)"
            >
              上一页
            </button>
            <span
              >{{ selectorPage.page }} /
              {{
                Math.max(1, Math.ceil(selectorPage.total / selectorPage.limit))
              }}</span
            >
            <button
              :disabled="
                selectorPage.page >=
                Math.max(1, Math.ceil(selectorPage.total / selectorPage.limit))
              "
              @click="loadGoods(selectorPage.page + 1)"
            >
              下一页
            </button>
            <el-select
              v-model="selectorPage.limit"
              popper-class="bm-sku-spec__select-popper"
              class="bm-sku-spec__page-size"
              @change="loadGoods(1)"
            >
              <el-option
                v-for="n in [10, 20, 50]"
                :key="n"
                :label="n + '条/页'"
                :value="n"
              />
            </el-select>
          </div>
          <label class="bm-sku-spec__select-all">
            <el-checkbox
              :value="selectorPageAllSelected"
              @change="togglePageGoods"
            />
            全选
          </label>
        </div>
        <main>
          <button
            v-for="g in displayedGoods"
            :key="g.product_id"
            :class="{ selected: selected.includes(String(g.product_id)) }"
            @click="toggleGood(g.product_id)"
          >
            <el-checkbox
              :value="selected.includes(String(g.product_id))"
              @click.native.stop
              @change="toggleGood(g.product_id)"
            />
            <img :src="imageOf(g)" alt="商品主图" />
            <span>{{ g.title || g.product_title }}</span>
            <small>{{ priceRange(g) }}</small>
          </button>
        </main>
        <footer>
          <span>已选 {{ selected.length }} 个商品</span>
          <button class="plain" @click="selecting = false">取消</button>
          <button @click="selecting = false">确定</button>
        </footer>
      </div>
    </div>
  </section>
</template>
<script>
import {
  previewCloudSkuSpecBatchProducts,
  previewCloudSkuSpecBatchSkus,
  createCloudSkuSpecBatch
} from '@/api/main/cloudBatchEdit'
import { cloudProductGroups, cloudProductList } from '@/api/main/ucenter'
const fields = [
  { key: 'group_id', label: '分组', placeholder: '请选择分组' },
  { key: 'child_group_id', label: '子分组', placeholder: '请选择子分组' },
  { key: 'created_range', label: '导入时间', range: true },
  { key: 'source_product_id', label: '来源ID', placeholder: '请输入来源ID' },
  { key: 'sku_status', label: 'SKU替换状态', select: true },
  { key: 'sku_mark_status', label: '商品标记状态', select: true },
  { key: 'ai_title_status', label: '标题替换状态', select: true },
  { key: 'source_web', label: '数据源', select: true }
]
export default {
  name: 'BatchModifySkuSpec',
  data() {
    return {
      mode: 'range',
      fields,
      addTime: [],
      groupList: [],
      childGroupList: [],
      statusOptions: {
        sku_status: [
          { label: '待替换', value: 1 },
          { label: '已替换', value: 2 },
          { label: '找不到', value: 3 }
        ],
        sku_mark_status: [
          { label: '未标记', value: 1 },
          { label: '已标记', value: 2 },
          { label: '找不到', value: 3 }
        ],
        ai_title_status: [
          { label: '待替换', value: 1 },
          { label: '已替换', value: 2 },
          { label: '异常', value: 9 }
        ],
        source_web: [
          { value: 9, label: '星好货' },
          { value: 3, label: 'TB' },
          { value: 4, label: 'PDD' },
          { value: 2, label: '1688' },
          { value: 5, label: 'DY' },
          { value: 6, label: 'WX' }
        ]
      },
      filterValues: {
        group_id: '',
        child_group_id: '',
        source_product_id: '',
        sku_status: '',
        sku_mark_status: '',
        ai_title_status: '',
        source_web: ''
      },
      selecting: false,
      selectorTab: 'all',
      selectorPage: { page: 1, limit: 20, total: 0 },
      selectorFilters: { group_id: '', child_group_id: '', source_product_id: '', keyword: '' },
      selectorChildGroups: [],
      selected: [],
      selectedGoods: [],
      goods: [],
      preview: null,
      previewGoods: [],
      previewPage: { page: 1, limit: 20, total: 0 },
      excludedProductIds: [],
      previewKey: '',
      previewLoading: false,
      submitting: false,
      form: {
        productIds: '',
        keyword: '',
        modifyTarget: 'spec_name',
        specSelection: 'all_spec',
        specMatchEnabled: false,
        specMatchField: 'spec_name:contains',
        specMatchKeywords: '',
        modifyMethod: 'delete_keyword',
        deleteKeywords: '',
        replaceRules: [{ search: '', replace: '' }],
        standardReplaceRules: [{ search: '', replace: '' }],
        prefix: '',
        suffix: '',
        newRemark: '',
        existingRemarkAction: 'skip',
        remarkAutoTruncate: false,
        remarkMaxLength: 18,
        remarkTruncateDirection: 'from_end',
        deleteRemarkMode: 'all'
      },
      modifyTargets: [
        { value: 'spec_name', label: 'SKU规格名称' },
        { value: 'remark', label: 'SKU备注' }
      ],
      specSelections: [
        { value: 'all_spec', label: '全部规格' },
        { value: 'spec_1', label: '第1个规格' },
        { value: 'spec_2', label: '第2个规格' }
      ],
      specMatchFields: [
        { value: 'spec_name:contains', label: 'SKU规格名称包含关键字' },
        { value: 'spec_name:not_contains', label: 'SKU规格名称不包含关键字' },
        { value: 'spec_name:exact', label: 'SKU规格名称精确为' },
        { value: 'remark:contains', label: 'SKU备注包含关键字' },
        { value: 'remark:not_contains', label: 'SKU备注不包含关键字' },
        { value: 'remark:exact', label: 'SKU备注精确为' }
      ],
      modifyMethods: {
        spec_name: [
          { value: 'delete_keyword', label: '删除关键字', on: true },
          { value: 'replace_keyword', label: '替换关键字', on: false, tooltip: '关键词存在商品的中的规格名和备注中才可替换（如替换后规格名和备注为空，就不再替换）' },
          { value: 'standard_replace', label: '精准替换', on: false, tooltip: '关键词必须与商品的中的规格名和备注完全一致才可替换（如替换后规格名和备注为空，就不再替换）' },
          { value: 'add_prefix_suffix', label: '添加前后缀', on: false }
        ],
        remark: [
          { value: 'add_remark', label: '添加备注', on: true },
          { value: 'delete_keyword', label: '删除关键字', on: false },
          { value: 'replace_keyword', label: '替换关键字', on: false, tooltip: '关键词存在商品的中的规格名和备注中才可替换（如替换后规格名和备注为空，就不再替换）' },
          { value: 'standard_replace', label: '精准替换', on: false, tooltip: '关键词必须与商品的中的规格名和备注完全一致才可替换（如替换后规格名和备注为空，就不再替换）' },
          { value: 'add_prefix_suffix', label: '添加前后缀', on: false },
          { value: 'delete_remark', label: '删除备注', on: false }
        ]
      }
    }
  },
  watch: {
    'form.modifyTarget'(newVal) {
      // 切换修改对象时，重置相关字段
      if (newVal === 'spec_name') {
        this.form.modifyMethod = 'delete_keyword'
        this.form.specMatchField = 'spec_name:contains'
      } else {
        this.form.modifyMethod = 'add_remark'
        this.form.specMatchField = 'remark:contains'
      }
      this.validate()
    },
    form: {
      deep: true,
      handler() {
        this.validate()
      }
    },
    filterValues: {
      deep: true,
      handler() {
        this.validate()
      }
    },
    addTime: {
      deep: true,
      handler() {
        this.validate()
      }
    },
    selected: {
      deep: true,
      handler() {
        this.validate()
      }
    },
    excludedProductIds: {
      deep: true,
      handler() {
        this.validate()
      }
    }
  },
  computed: {
    // 根据修改对象返回可用的修改方法
    availableMethods() {
      return this.modifyMethods[this.form.modifyTarget] || []
    },
    // SKU筛选字段选项（根据修改对象动态变化）
    availableSpecMatchFields() {
      if (this.form.modifyTarget === 'spec_name') {
        return this.specMatchFields.filter(f => f.value.startsWith('spec_name'))
      } else {
        return this.specMatchFields.filter(f => f.value.startsWith('remark'))
      }
    },
    // 关键字数量统计
    specMatchKeywordCount() {
      return this.form.specMatchKeywords
        .split(/[,，]/)
        .map(k => k.trim())
        .filter(Boolean).length
    },
    imageOf() {
      return (g) => g.main_image || g.image_url || (Array.isArray(g.main_images) && g.main_images[0]) || ''
    },
    displayedGoods() {
      if (this.selectorTab === 'selected') {
        const s = (this.selectorPage.page - 1) * this.selectorPage.limit
        return this.selectedGoods.slice(s, s + this.selectorPage.limit)
      }
      return this.goods
    },
    selectorPageAllSelected() {
      return (
        this.displayedGoods.length > 0 && this.displayedGoods.every((g) => this.selected.includes(String(g.product_id)))
      )
    },
    canCreate() {
      return !!this.preview && this.previewKey === this.payloadKey()
    },
    pageCount() {
      return Math.max(1, Math.ceil(this.previewPage.total / this.previewPage.limit))
    }
  },
  created() {
    this.loadGroups()
  },
  methods: {
    async loadGroups() {
      try {
        const r = await cloudProductGroups({ with_count: 0 })
        this.groupList = (r.data && (r.data.data || r.data)) || []
      } catch (e) {
        this.$message.error('请求失败，请稍后重试')
      }
    },
    optionsFor(k) {
      return k === 'group_id'
        ? this.groupList.map((i) => ({ value: i.id, label: i.name || i.group_name }))
        : k === 'child_group_id'
        ? this.childGroupList.map((i) => ({ value: i.id, label: i.name || i.group_name }))
        : this.statusOptions[k] || []
    },
    onGroupChange() {
      const g = this.groupList.find((i) => String(i.id) === String(this.filterValues.group_id))
      this.childGroupList = (g && g.child_groups) || []
      this.filterValues.child_group_id = ''
      this.validate()
    },
    loadSku(item) {
      const id = String(item.product_id)
      if (item._skuOpen) {
        this.$set(item, '_skuOpen', false)
        return
      }
      this.$set(item, '_skuLoading', true)
      const p = this.buildPayload()
      previewCloudSkuSpecBatchSkus({
        ...p,
        product_id: id
      })
        .then((r) => {
          const d = (r.data && (r.data.data || r.data)) || {}
          this.$set(item, '_skus', Array.isArray(d) ? d : d.skus || d.items || d.list || [])
          this.$set(item, '_skuOpen', true)
        })
        .catch(() => this.$set(item, '_skuError', 'SKU查询失败'))
        .finally(() => this.$set(item, '_skuLoading', false))
    },
    skuRows(item) {
      return item.skus || item.sku_list || item._skus || []
    },
    previewPrice(item, key) {
      if (item[key] != null) return item[key]
      const rows = this.skuRows(item)
      if (!rows.length) return '无数据'
      const values = rows.map((row) => row[key]).filter((value) => value != null && value !== '')
      if (!values.length) return '无数据'
      if (values.length === 1 || values.every((value) => String(value) === String(values[0]))) return values[0]
      return `${values[0]} ~ ${values[values.length - 1]}`
    },
    sourceLabel(value) {
      const labels = { 9: '星好货', 3: 'TB', 4: 'PDD', 2: '1688', 5: 'DY', 6: 'WX' }
      return labels[String(value)] || value || '未知'
    },
    priceRange(good) {
      const min = good.min_price ?? good.price_min ?? good.price
      const max = good.max_price ?? good.price_max ?? min
      return min === undefined || min === null ? '价格待定' : `¥${min}~¥${max}`
    },
    switchSelectorTab(t) {
      this.selectorTab = t
      if (t === 'selected') {
        this.selectorPage.total = this.selectedGoods.length
        this.selectorPage.page = 1
      } else this.loadGoods(1)
    },
    loadSelectorGroups() {
      const g = this.groupList.find((x) => String(x.id) === String(this.selectorFilters.group_id))
      this.selectorChildGroups = (g && g.child_groups) || []
      this.selectorFilters.child_group_id = ''
      this.loadGoods(1)
    },
    toggleGood(id) {
      id = String(id)
      if (!id || id === 'undefined' || id === 'null') return
      const i = this.selected.indexOf(id)
      if (i >= 0) {
        this.selected.splice(i, 1)
        this.selectedGoods = this.selectedGoods.filter((g) => String(g.product_id) !== id)
      } else {
        this.selected.push(id)
        const g = this.goods.find((x) => String(x.product_id) === id)
        if (g) this.selectedGoods.push(g)
      }
    },
    togglePageGoods(c) {
      this.displayedGoods.forEach((g) => {
        const id = String(g.product_id)
        if (!id || id === 'undefined' || id === 'null') return
        if (c && !this.selected.includes(id)) {
          this.selected.push(id)
          this.selectedGoods.push(g)
        }
        if (!c) {
          const i = this.selected.indexOf(id)
          if (i >= 0) this.selected.splice(i, 1)
          this.selectedGoods = this.selectedGoods.filter((x) => String(x.product_id) !== id)
        }
      })
    },
    loadGoods(page = 1) {
      return cloudProductList({ page, page_size: this.selectorPage.limit, status: 1, ...this.selectorFilters })
        .then((r) => {
          const d = (r.data && (r.data.data || r.data)) || {}
          this.goods = d.list || d.data || d
          this.selectorPage = { ...this.selectorPage, page, total: Number(d.total || this.goods.length) }
        })
        .catch(() => this.$message.error('商品查询失败'))
    },
    switchMode(m) {
      this.mode = m
      this.previewPage.page = 1
      this.validate()
    },
    validate() {
      const f = this.form

      // 1. 检查商品选择
      if (this.mode === 'goods' && this.selected.length === 0) {
        return '请选择商品'
      }

      // 2. 检查规格选择
      if (!f.specSelection) {
        return '请选择要修改的规格'
      }

      // 3. 检查SKU筛选关键字
      if (f.specMatchEnabled) {
        const keywords = f.specMatchKeywords
          .split(/[,，\r\n]+/)
          .map(k => k.trim())
          .filter(Boolean)

        if (keywords.length === 0) {
          return '请输入筛选关键字'
        }

        if (keywords.length > 100) {
          return '关键字数量不能超过100个'
        }
      }

      // 4. 检查修改方法和参数
      const method = f.modifyMethod

      if (method === 'add_remark') {
        if (!f.newRemark || !f.newRemark.trim()) {
          return '请输入备注内容'
        }
      } else if (method === 'delete_keyword') {
        if (!f.deleteKeywords || !f.deleteKeywords.trim()) {
          return '请输入要删除的关键字'
        }
      } else if (method === 'replace_keyword') {
        const hasEmpty = f.replaceRules.some(r => !r.search || !r.search.trim())
        if (hasEmpty || f.replaceRules.length === 0) {
          return '请填写完整的替换规则'
        }
      } else if (method === 'standard_replace') {
        const hasEmpty = f.standardReplaceRules.some(r => !r.search || !r.search.trim())
        if (hasEmpty || f.standardReplaceRules.length === 0) {
          return '请填写完整的替换规则'
        }
      } else if (method === 'add_prefix_suffix') {
        if ((!f.prefix || !f.prefix.trim()) && (!f.suffix || !f.suffix.trim())) {
          return '前缀和后缀至少填写一个'
        }
      }
      this.preview = null
      this.previewKey = ''
      this.skuCache = {}
      this.previewPage.page = 1
      return ''
    },
    async previewBatch() {
      const e = this.validate()
      if (e) return this.$message.warning(e)
      this.previewLoading = true
      try {
        const r = await previewCloudSkuSpecBatchProducts({
          ...this.buildPayload(),
          page: this.previewPage.page,
          limit: this.previewPage.limit
        })
        const body = r && r.data && r.data.code !== undefined ? r.data : r
        if (body && body.code && body.code !== 200) throw Error(body.msg || body.message || '预览失败')
        this.preview = (r.data && (r.data.data || r.data)) || {}
        this.previewGoods = this.preview.list || this.preview.products || this.preview.items || []
        this.previewPage.total = Number(
          this.preview.product_count || this.preview.total || this.previewGoods.length || 0
        )
        this.previewKey = this.payloadKey()
      } catch (e) {
        this.validate()
        this.$message.error(
          (e.response && e.response.data && (e.response.data.msg || e.response.data.message)) ||
            e.message ||
            '请求失败，请稍后重试'
        )
      } finally {
        this.previewLoading = false
      }
    },
    async previewBatchPage(page) {
      this.previewPage.page = page
      await this.previewBatch()
    },
    async createBatch() {
      if (!this.canCreate) return this.$message.warning('请先预览当前修改规则')

      // 检查商品数量
      const totalProducts = this.previewPage?.total || 0
      if (totalProducts <= 0) {
        this.$message.warning('商品数小于0，请选择商品后点击修改预览')
        return
      }

      // 弹出确认提示
      try {
        await this.$confirm(`商品数${totalProducts}，是否开始修改？`, '确认修改', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (e) {
        // 用户点击取消
        return
      }

      this.submitting = true
      try {
        const r = await createCloudSkuSpecBatch(this.buildPayload())
        const body = r && r.data && r.data.code !== undefined ? r.data : r
        if (body && body.code && body.code !== 200) throw Error(body.msg || body.message || '任务创建失败')
        this.$message.success('任务已创建')
        this.$emit('back')
      } catch (e) {
        this.$message.error(
          (e.response && e.response.data && (e.response.data.msg || e.response.data.message)) ||
            e.message ||
            '请求失败，请稍后重试'
        )
      } finally {
        this.submitting = false
      }
    },
    buildPayload() {
      const f = this.form
      const payload = {}

      // 商品范围
      if (this.mode === 'goods') {
        payload.product_ids = this.selected.join(',')
      } else {
        payload.product_filter = this.filterValues
      }

      // 排除的商品ID（仅在有排除项时添加）
      if (this.excludedProductIds.length > 0) {
        payload.excluded_product_ids = this.excludedProductIds.join(',')
      }

      // 规则配置对象
      const rule = {
        modify_target: f.modifyTarget,
        spec_selection: f.specSelection
      }

      // 找到选中的修改方法
      const selectedMethod = this.availableMethods.find(m => m.on)
      if (selectedMethod) {
        rule.modify_method = selectedMethod.value

        // 只构建选中方法的参数
        if (selectedMethod.value === 'delete_keyword') {
          rule.delete_keywords = f.deleteKeywords
        } else if (selectedMethod.value === 'replace_keyword') {
          rule.replace_rules = f.replaceRules
        } else if (selectedMethod.value === 'standard_replace') {
          rule.replace_rules = f.standardReplaceRules
        } else if (selectedMethod.value === 'add_prefix_suffix') {
          rule.prefix = f.prefix
          rule.suffix = f.suffix
        } else if (selectedMethod.value === 'add_remark') {
          rule.new_remark = f.newRemark
          rule.existing_remark_action = f.existingRemarkAction
        } else if (selectedMethod.value === 'delete_remark') {
          rule.delete_remark_mode = f.deleteRemarkMode
        }
      }

      // SKU筛选（仅在启用时添加）
      if (f.specMatchEnabled) {
        rule.spec_match_field = f.specMatchField
        rule.spec_match_keywords = f.specMatchKeywords
      }

      // 备注截断（仅在修改备注且启用时添加）
      if (f.modifyTarget === 'remark' && f.remarkAutoTruncate) {
        rule.remark_auto_truncate = true
        rule.remark_max_length = f.remarkMaxLength
        rule.remark_truncate_direction = f.remarkTruncateDirection
      }

      payload.rule = rule

      return payload
    },
    payloadKey() {
      // 生成当前配置的唯一标识符，用于判断预览和创建时的配置是否一致
      return JSON.stringify(this.buildPayload())
    },
    toggleExclude(g) {
      const id = String(g.product_id),
        i = this.excludedProductIds.indexOf(id)
      if (!id || id === 'undefined' || id === 'null') return
      i < 0 ? this.excludedProductIds.push(id) : this.excludedProductIds.splice(i, 1)
      this.validate()
    },
    reset() {
      Object.assign(this.filterValues, {
        group_id: '',
        child_group_id: '',
        source_product_id: '',
        sku_status: '',
        sku_mark_status: '',
        ai_title_status: '',
        source_web: ''
      })
      this.addTime = []
      Object.assign(this.form, {
        productIds: '',
        keyword: '',
        modifyTarget: 'spec_name',
        specSelection: 'all_spec',
        specMatchEnabled: false,
        specMatchField: 'spec_name:contains',
        specMatchKeywords: '',
        modifyMethod: 'delete_keyword',
        deleteKeywords: '',
        replaceRules: [{ search: '', replace: '' }],
        standardReplaceRules: [{ search: '', replace: '' }],
        prefix: '',
        suffix: '',
        newRemark: '',
        existingRemarkAction: 'skip',
        remarkAutoTruncate: false,
        remarkMaxLength: 18,
        remarkTruncateDirection: 'from_start'
      })
      this.selected = []
      this.validate()
    },
    async openSelector() {
      this.selecting = true
      this.selectorTab = 'all'
      await this.loadGroups()
      this.loadSelectorGroups()
      await this.loadGoods(1)
    },
    // 添加替换规则
    addReplaceRule() {
      this.form.replaceRules.push({ search: '', replace: '' })
    },
    // 删除替换规则
    removeReplaceRule(index) {
      if (this.form.replaceRules.length > 1) {
        this.form.replaceRules.splice(index, 1)
      }
    },
    // 添加精准替换规则
    addStandardReplaceRule() {
      this.form.standardReplaceRules.push({ search: '', replace: '' })
    },
    // 删除精准替换规则
    removeStandardReplaceRule(index) {
      if (this.form.standardReplaceRules.length > 1) {
        this.form.standardReplaceRules.splice(index, 1)
      }
    },
    // 处理方法选择变化
    handleMethodChange(index) {
      // 点击某个方式时，取消其他所有方式的选中状态
      this.availableMethods.forEach((method, i) => {
        if (i !== index) {
          method.on = false
        }
      })
      // 更新 form.modifyMethod
      const selectedMethod = this.availableMethods.find(m => m.on)
      if (selectedMethod) {
        this.form.modifyMethod = selectedMethod.value
      } else {
        this.form.modifyMethod = ''
      }
    },
    // 处理修改对象变化
    handleModifyTargetChange(value) {
      this.form.modifyTarget = value
      // 如果选择了"仅修改备注"，强制开启备注截断
      if (value === 'remark') {
        this.form.remarkAutoTruncate = true
      }
      // 重置所有方法的选中状态，并将方式1设为选中
      this.modifyMethods[value].forEach((method, index) => {
        method.on = index === 0
      })
      // 更新 form.modifyMethod 为第一个方法
      this.form.modifyMethod = this.modifyMethods[value][0].value
    },
    // 处理规格选择变化
    handleSpecSelectionChange(value) {
      this.form.specSelection = value
    },
    // 处理SKU筛选变化（与 BatchModifyPrice.vue 的 toggleChild 一致）
    toggleSpecMatch(value, checked) {
      if (checked) {
        this.form.specMatchEnabled = value
      }
    },
    // 处理备注截断变化（与 BatchModifyPrice.vue 的 toggleChild 一致）
    toggleRemarkTruncate(value, checked) {
      if (checked) {
        this.form.remarkAutoTruncate = value
      }
    }
  }
}
</script>
<style scoped>
/* 复用 BatchModifyTitle 的样式，只需替换 bm-title 为 bm-sku-spec */
.bm-sku-spec {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  min-height: calc(100vh - 56px);
  overflow-x: hidden;
  background: #f5f6f8;
  color: #1a1a2e;
  font-family: 'Noto Sans SC', sans-serif;
}

.bm-sku-spec__preview tr:nth-child(even) {
  background: #fcfcfd;
}

.bm-sku-spec__preview tr:hover {
  background: #f0f7ff;
}

.bm-sku-spec__preview tr.is-excluded {
  background: #e5e5e5;
  color: #777;
}

.bm-sku-spec button,
.bm-sku-spec input,
.bm-sku-spec select,
.bm-sku-spec textarea {
  font: inherit;
}

.bm-sku-spec button {
  cursor: pointer;
}

.bm-sku-spec__head {
  background: #fff;
  border-bottom: 1px solid #e0e0ec;
  padding: 10px 20px 0;
}

.bm-sku-spec__crumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #999;
}

.bm-sku-spec__crumb button {
  height: 26px;
  padding: 0 10px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
}

.bm-sku-spec__crumb a {
  margin-left: auto;
  color: #1677ff;
}

.bm-sku-spec h1 {
  margin: 12px 0 8px;
  font: 600 18px 'Noto Serif SC', serif;
}

.bm-sku-spec__head nav {
  display: flex;
  gap: 22px;
}

.bm-sku-spec__head nav button {
  padding: 9px 6px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: #fff;
  color: #666;
  font-size: 13px;
}

.bm-sku-spec__head nav button.active {
  border-bottom-color: #c8443c;
  color: #c8443c;
  font-weight: 600;
}

.bm-sku-spec__body {
  padding: 14px 20px 82px;
}

.bm-sku-spec__filter {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px 14px;
  padding: 14px 16px 10px;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}

.bm-sku-spec__field label {
  display: block;
  margin-bottom: 4px;
  color: #666;
  font-size: 10px;
}

.bm-sku-spec__field input,
.bm-sku-spec__field select,
.bm-sku-spec__method-content input,
.bm-sku-spec__method-content select,
.bm-sku-spec__method-content textarea {
  box-sizing: border-box;
  width: 100%;
  height: 28px;
  padding: 4px 8px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  font-size: 11px;
}

.bm-sku-spec__date-range {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  gap: 5px;
}

.bm-sku-spec__date-input {
  flex: 1 1 0;
  min-width: 0;
  box-sizing: border-box;
  width: 0;
  height: 28px;
  padding: 4px 8px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
  font-size: 11px;
}

.bm-sku-spec__date-separator {
  flex: 0 0 12px;
  color: #999;
  text-align: center;
}

.bm-sku-spec__filter footer {
  grid-column: 1/-1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding-top: 9px;
  border-top: 1px solid #f0f0f0;
  font-size: 12px;
}

.bm-sku-spec__filter button,
.bm-sku-spec__picked button,
.bm-sku-spec__small-modal footer button,
.bm-sku-spec__select-modal footer button {
  height: 28px;
  padding: 0 13px;
  border: 0;
  border-radius: 4px;
  background: #c8443c;
  color: #fff;
  font-size: 12px;
}

.bm-sku-spec__filter .plain {
  border: 1px solid #e0e0ec;
  background: #fff;
  color: #666;
}

.bm-sku-spec__picked {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 14px;
  padding: 10px 14px;
  border: 1px solid #e0e0ec;
  border-radius: 6px;
  background: #fff;
  color: #666;
  font-size: 12px;
}

.bm-sku-spec__picked button {
  background: #1677ff;
}

.bm-sku-spec__picked span {
  color: #1677ff;
}

.bm-sku-spec__methods {
  overflow: hidden;
  margin-top: 14px;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}

.bm-sku-spec__methods>header {
  padding: 10px 14px;
  border-bottom: 1px solid #e0e0ec;
  background: #f5f0e8;
  font-size: 12px;
  font-weight: 600;
}

.bm-sku-spec__methods>header i {
  display: inline-block;
  width: 3px;
  height: 14px;
  margin-right: 7px;
  border-radius: 2px;
  background: #c8443c;
  vertical-align: middle;
}

.bm-sku-spec__methods article {
  padding: 15px 30px;
  border-bottom: 1px solid #e0e0ec;
  font-size: 12px;
}

.bm-sku-spec__methods article:last-child {
  border-bottom: 0;
}

.bm-sku-spec__method-name {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #1a1a2e;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  cursor: pointer;
}

.scope-item-group {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: nowrap;
}

.scope-title {
  font-weight: 500;
  font-size: 13px;
  color: #1a1a2e;
  line-height: 18px;
  flex-shrink: 0;
  white-space: nowrap;
}

.sku-scope-row {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: nowrap;
}

.sku-scope-config {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: nowrap;
  white-space: nowrap;
  flex: 1;
}

.sku-scope-config .bm-sku-spec__select {
  flex-shrink: 0;
  width: 160px;
  min-width: 160px;
}

.sku-scope-config .el-input {
  flex-shrink: 0;
  width: 400px;
  min-width: 400px;
  max-width: 400px;
}

.sku-scope-config input,
.sku-scope-config .el-input__inner {
  white-space: nowrap;
}

.sku-keyword-count {
  flex-shrink: 0;
  color: #999;
  font-size: 10px;
  white-space: nowrap;
  margin-left: 5px;
}

.bm-sku-spec__method-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 10px 0 0 22px;
  color: #666;
}

.bm-sku-spec__method-content input[type='checkbox'],
.bm-sku-spec__method-content input[type='radio'] {
  width: 14px;
  height: 14px;
  min-width: 14px;
  margin: 0;
  padding: 0;
  accent-color: #1677ff;
  cursor: pointer;
  -webkit-appearance: auto;
  appearance: auto;
  border: 1px solid #d9c98d;
}

.bm-sku-spec__radio-group {
  display: flex;
  gap: 20px;
  align-items: center;
}

.bm-sku-spec__radio-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.bm-sku-spec__radio {
  flex-shrink: 0;
}

.bm-sku-spec__method-content>label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  cursor: pointer;
}

.bm-sku-spec__method-content>span {
  flex-shrink: 0;
  color: #666;
  font-size: 12px;
}

.bm-sku-spec__method-content input[type='text'],
.bm-sku-spec__method-content input:not([type='checkbox']):not([type='radio']) {
  width: 190px;
}

.bm-sku-spec__method-content input.long {
  width: 360px;
}

.bm-sku-spec__method-content textarea {
  width: 100%;
  max-width: 600px;
  min-height: 80px;
  height: auto;
  resize: vertical;
  line-height: 1.5;
}

.bm-sku-spec__method-content small {
  color: #999;
  font-size: 10px;
}

.bm-sku-spec__single-input {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.bm-sku-spec__single-input input {
  width: 500px;
  padding-right: 8px;
}

.bm-sku-spec__single-input small {
  flex-shrink: 0;
  color: #999;
  font-size: 10px;
}

.bm-sku-spec__multi-input {
  position: relative;
  width: 100%;
  max-width: 600px;
}

.bm-sku-spec__multi-input textarea {
  width: 100%;
  max-width: 600px;
  min-height: 80px;
  padding-right: 8px;
  padding-bottom: 20px;
}

.bm-sku-spec__multi-input small {
  position: absolute;
  right: 8px;
  bottom: 8px;
  color: #999;
  font-size: 10px;
}

.bm-sku-spec__count-input,
.bm-sku-spec__count-textarea {
  position: relative;
  width: fit-content;
  max-width: 600px;
  line-height: normal;
}

.bm-sku-spec__count-input input {
  width: 360px;
  padding-right: 60px;
}

.bm-sku-spec__count-input small,
.bm-sku-spec__count-textarea small {
  position: absolute;
  right: 8px;
  bottom: 8px;
  color: #999;
  font: 10px 'JetBrains Mono', monospace;
  background: rgba(255, 255, 255, 0.9);
  padding: 2px 4px;
  border-radius: 2px;
}

.bm-sku-spec__count-textarea textarea {
  width: 100%;
  min-height: 80px;
  padding: 8px;
  padding-bottom: 24px;
  box-sizing: border-box;
}

.bm-sku-spec__inline {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.bm-sku-spec__inline input:not([type='checkbox']):not([type='radio']) {
  width: 200px;
}

.bm-sku-spec__replace {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.bm-sku-spec__replace input {
  width: 160px;
}

.bm-sku-spec__replace button {
  height: 28px;
  padding: 0 10px;
  border: 1px solid #91caff;
  border-radius: 4px;
  background: #e6f4ff;
  color: #1677ff;
  font-size: 11px;
}

.bm-sku-spec__replace .danger {
  border-color: #ffccd2;
  background: #fff5f5;
  color: #c8443c;
}

.bm-sku-spec__preview {
  overflow: hidden;
  margin-top: 14px;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}

.bm-sku-spec__preview header {
  padding: 10px 14px;
  border-bottom: 1px solid #e0e0ec;
  font-size: 12px;
}

.bm-sku-spec__preview header b {
  color: #1677ff;
}

.bm-sku-spec__preview header button {
  float: right;
  border: 0;
  background: none;
  color: #c8443c;
}

.bm-sku-spec__preview table {
  width: 100%;
  border-collapse: collapse;
}

.bm-sku-spec__preview th {
  padding: 8px 12px;
  background: #f5f0e8;
  color: #666;
  font-size: 11px;
  font-weight: 500;
  text-align: left;
}

.bm-sku-spec__preview td {
  padding: 10px 12px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 11px;
}

.bm-sku-spec__preview td:first-child {
  display: flex;
  align-items: center;
  gap: 8px;
}

.bm-sku-spec__preview p {
  margin: 3px 0 0;
}

.bm-sku-spec__preview small {
  color: #999;
}

.bm-sku-spec__preview textarea {
  width: 100%;
  min-height: 38px;
  box-sizing: border-box;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  font-size: 11px;
}

.bm-sku-spec__preview .huohao-cell {
  min-width: 200px;
  max-width: 300px;
}

.bm-sku-spec__preview .huohao-cell textarea {
  width: 100%;
  min-width: 200px;
  padding: 5px;
  line-height: 1.4;
  background: #fafcff;
  resize: vertical;
}

.bm-sku-spec__preview .huohao-display {
  padding: 8px;
  min-height: 38px;
  word-break: break-all;
  line-height: 1.4;
  color: #666;
  background: #f5f5f5;
  border-radius: 4px;
}

.bm-sku-spec__preview td button {
  height: 24px;
  border: 1px solid #91caff;
  border-radius: 3px;
  background: #e6f4ff;
  color: #1677ff;
  font-size: 10px;
}

.bm-sku-spec__preview .action-cell {
  min-width: 110px;
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;
}

.bm-sku-spec__preview .action-cell button {
  min-width: 82px;
  height: 30px;
  padding: 0 12px;
  border-color: #91caff;
  border-radius: 5px;
  background: #e6f4ff;
  color: #1677ff;
  font-size: 12px;
  line-height: 28px;
  transition: 0.2s;
}

.bm-sku-spec__preview .action-cell button:hover,
.bm-sku-spec__preview .action-cell button:focus {
  border-color: #409eff;
  background: #bae0ff;
  color: #0958d9;
}

.bm-sku-spec__preview .action-cell button.restore {
  border-color: #ffd591;
  background: #fff7e6;
  color: #d46b08;
}

.bm-sku-spec__preview .action-cell button.restore:hover,
.bm-sku-spec__preview .action-cell button.restore:focus {
  border-color: #ffa940;
  background: #ffe7ba;
  color: #ad4e00;
}

.bm-sku-spec__preview .bm-sku-spec__sku-list .sku-matched-row {
  background: #f0f9eb;
}

.bm-sku-spec__preview .bm-sku-spec__sku-list .sku-unmatched-row {
  background: #f5f5f5;
  color: #909399;
}

.bm-sku-spec__preview .bm-sku-spec__sku-list .sku-failed-row {
  background: #fef0f0;
}

.bm-sku-spec__sku-list .sku-error {
  color: #f56c6c;
}

.bm-sku-spec__image {
  display: inline-flex;
  position: relative;
  z-index: 1;
  width: 46px;
  height: 46px;
  align-items: center;
  justify-content: center;
  border: 1px solid #ffccd2;
  border-radius: 4px;
  background: #fff5f5;
  object-fit: cover;
  font-size: 16px;
  cursor: pointer;
}

.bm-sku-spec__pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 10px 14px;
  border-top: 1px solid #f0f0f0;
  color: #666;
  font-size: 12px;
}

.bm-sku-spec__pagination button {
  padding: 4px 10px;
  border: 1px solid #d9e2f0;
  border-radius: 4px;
  background: #fff;
  color: #1677ff;
}

.bm-sku-spec__pagination button:disabled {
  color: #bbb;
  cursor: not-allowed;
}

.bm-sku-spec__pagination select {
  height: 26px;
  border: 1px solid #d9e2f0;
  border-radius: 4px;
}

.bm-sku-spec__bottom {
  position: fixed;
  left: var(--merchant-sidebar-width, 210px);
  right: 0;
  z-index: 20;
  bottom: 0;
  display: flex;
  width: auto;
  max-width: none;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: hidden;
  flex-wrap: nowrap;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  border-top: 1px solid #e0e0ec;
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  font-size: 12px;
}

.bm-sku-spec__bottom button {
  min-width: 0;
  flex: 0 1 auto;
  height: 30px;
  padding: 0 14px;
  border: 0;
  border-radius: 4px;
  color: #fff;
}

.bm-sku-spec__bottom .preview {
  background: #1677ff;
}

.bm-sku-spec__bottom .start {
  margin-left: auto;
  margin-right: 50px;
  padding: 0 28px;
  background: #52c41a;
}

.bm-sku-spec__mask {
  position: fixed;
  z-index: 3000;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(3px);
}

.bm-sku-spec__select-modal,
.bm-sku-spec__small-modal {
  width: min(1180px, 96vw);
  min-width: 900px;
  overflow: hidden;
  border: 1px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
}

.bm-sku-spec__small-modal {
  width: min(400px, 100%);
  min-width: 0;
}

.bm-sku-spec__select-modal>header,
.bm-sku-spec__small-modal>header {
  display: flex;
  justify-content: space-between;
  padding: 12px 18px;
  border-bottom: 1px solid #e0e0ec;
  background: #fafafa;
  font-size: 14px;
}

.bm-sku-spec__select-modal>header button,
.bm-sku-spec__small-modal>header button {
  width: 24px;
  height: 24px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
  font-size: 18px;
}

.bm-sku-spec__select-modal nav {
  display: flex;
  padding: 0 18px;
  border-bottom: 1px solid #e0e0ec;
}

.bm-sku-spec__select-modal nav button {
  padding: 10px 14px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: #fff;
  color: #666;
  font-size: 12px;
}

.bm-sku-spec__select-modal nav button.active {
  border-bottom-color: #1677ff;
  color: #1677ff;
}

.bm-sku-spec__selector-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 18px;
  background: #fafafa;
}

.bm-sku-spec__selector-toolbar .bm-sku-spec__select-filter {
  flex: 1;
  padding: 0;
  background: transparent;
}

.bm-sku-spec__select-filter {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.bm-sku-spec__select-filter input {
  width: 150px;
  height: 28px;
  padding: 4px 8px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  font-size: 11px;
  line-height: 18px;
  box-sizing: border-box;
}

.bm-sku-spec__select-filter button {
  height: 28px;
  padding: 0 12px;
  border: 0;
  border-radius: 4px;
  background: #1677ff;
  color: #fff;
  font-size: 11px;
}

.bm-sku-spec__group-select {
  width: 108px;
}

.bm-sku-spec__page-size {
  width: 96px;
}

.bm-sku-spec__selector-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 0;
  color: #666;
  font-size: 12px;
}

.bm-sku-spec__selector-pagination button {
  padding: 3px 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  color: #606266;
}

.bm-sku-spec__selector-pagination button:disabled {
  cursor: not-allowed;
  opacity: .5;
}

.bm-sku-spec__select-all {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  margin-left: auto;
  white-space: nowrap;
  gap: 6px;
  font-size: 12px;
}

.bm-sku-spec__select-modal main {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;
  max-height: 350px;
  padding: 14px 18px;
  overflow: auto;
}

.bm-sku-spec__select-modal main button {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  border: 2px solid #e0e0ec;
  border-radius: 6px;
  background: #fff;
  color: #1a1a2e;
  text-align: left;
  min-height: 150px;
}

.bm-sku-spec__select-modal main button.selected {
  border-color: #1677ff;
  background: #e6f4ff;
}

.bm-sku-spec__select-modal main img {
  width: 100%;
  height: 159px;
  object-fit: contain;
  background: #fff5f5;
}

.bm-sku-spec__select-modal main span {
  overflow: hidden;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bm-sku-spec__select-modal main small {
  color: #999;
  font-size: 10px;
}

.bm-sku-spec__select-modal footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  align-items: center;
  padding: 10px 18px;
  border-top: 1px solid #e0e0ec;
  font-size: 12px;
}

.bm-sku-spec__select-modal footer>span {
  margin-right: auto;
}

.bm-sku-spec__select-modal footer button {
  background: #1677ff;
}

.bm-sku-spec__select-modal footer .plain {
  border: 1px solid #e0e0ec;
  background: #fff;
  color: #666;
}

.bm-sku-spec__small-modal main {
  padding: 24px 20px;
  font-size: 13px;
}

.bm-sku-spec__small-modal footer {
  display: flex;
  justify-content: center;
  gap: 8px;
  padding: 12px 18px;
  border-top: 1px solid #e0e0ec;
}

.bm-sku-spec__small-modal footer button {
  width: 120px;
  height: 32px;
  border: 0;
  border-radius: 6px;
  background: #1677ff;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}

.bm-sku-spec__small-modal .success-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.bm-sku-spec__small-modal .success-message b {
  display: flex;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f6ffed;
  color: #52c41a;
  font-size: 28px;
}

.bm-sku-spec__small-modal .success-message p {
  margin: 12px 0 5px;
}

.bm-sku-spec__small-modal .success-message small {
  color: #999;
}

::v-deep(.bm-sku-spec__methods .el-checkbox__inner) {
  width: 14px;
  height: 14px;
  border-color: #d9c98d;
  border-radius: 3px;
}

::v-deep(.bm-sku-spec__methods .el-checkbox__inner:hover),
::v-deep(.bm-sku-spec__methods .el-checkbox__input.is-focus .el-checkbox__inner) {
  border-color: #d4a946;
}

::v-deep(.bm-sku-spec__methods .el-checkbox__input.is-checked .el-checkbox__inner),
::v-deep(.bm-sku-spec__methods .el-checkbox__input.is-indeterminate .el-checkbox__inner) {
  border-color: #d4a946;
  background: #d4a946;
}

::v-deep(.bm-sku-spec__methods .el-checkbox__label) {
  color: #1a1a2e;
  font-size: 12px;
  padding-left: 5px;
}

::v-deep(.bm-sku-spec__methods .el-checkbox__input.is-checked + .el-checkbox__label) {
  color: #1a1a2e;
}

::v-deep(.bm-sku-spec__image .el-image__inner) {
  border-radius: 4px;
  cursor: pointer;
}

.bm-sku-spec__filter-select {
  display: block;
  width: 100%;
}

::v-deep(.bm-sku-spec__filter-select .el-input__inner),
::v-deep(.bm-sku-spec__group-select .el-input__inner),
::v-deep(.bm-sku-spec__page-size .el-input__inner) {
  height: 28px;
  padding: 0 28px 0 8px;
  border-color: #e0e0ec;
  border-radius: 4px;
  color: #1a1a2e;
  font-size: 12px;
  line-height: 28px;
  text-align: left;
}

::v-deep(.bm-sku-spec__filter-select .el-input__suffix),
::v-deep(.bm-sku-spec__group-select .el-input__suffix),
::v-deep(.bm-sku-spec__page-size .el-input__suffix) {
  right: 7px;
}

::v-deep(.bm-sku-spec__filter-select .el-input__icon),
::v-deep(.bm-sku-spec__group-select .el-input__icon),
::v-deep(.bm-sku-spec__page-size .el-input__icon) {
  color: #999;
  font-size: 14px;
  line-height: 28px;
}

::v-deep(.bm-sku-spec__filter-select .el-input__inner:focus),
::v-deep(.bm-sku-spec__group-select .el-input__inner:focus),
::v-deep(.bm-sku-spec__page-size .el-input__inner:focus) {
  border-color: #d4a946;
}

@media (max-width: 960px) {
  .bm-sku-spec__filter {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .bm-sku-spec__select-modal {
    min-width: 0;
  }

  .bm-sku-spec__select-modal main {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .bm-sku-spec__selector-toolbar {
    flex-wrap: wrap;
  }
}

@media (max-width: 720px) {
  .bm-sku-spec__filter {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .bm-sku-spec__select-modal main {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .bm-sku-spec__bottom .start {
    margin-left: 0;
  }
}

@media (max-width: 520px) {

  .bm-sku-spec__head,
  .bm-sku-spec__body {
    padding-right: 12px;
    padding-left: 12px;
  }

  .bm-sku-spec__filter {
    grid-template-columns: 1fr;
  }

  .bm-sku-spec__method-content input,
  .bm-sku-spec__method-content input.long,
  .bm-sku-spec__method-content textarea {
    width: 100%;
  }

  .bm-sku-spec__select-modal main {
    grid-template-columns: repeat(2, 1fr);
  }

  .bm-sku-spec__bottom {
    left: 0;
    gap: 6px;
    padding: 8px 12px;
  }

  .bm-sku-spec__bottom .start {
    padding: 0 12px;
  }

  .bm-sku-spec__bottom .preview {
    display: none;
  }
}
</style>
<style>
.el-popper.bm-sku-spec__select-popper {
  z-index: 4000 !important;
}

.bm-sku-spec__methods > .el-radio-group,
.bm-sku-spec__methods article > .bm-sku-spec__method-content:first-child {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.bm-sku-spec__methods article > .bm-sku-spec__method-content {
  width: calc(100% - 22px);
}

.sku-methods {
  padding: 0;
  margin-bottom: 18px;
}

.sku-methods > header,
.price-methods > header {
  margin: 0;
  padding: 12px 16px;
  background: #f8f5ef;
  border-bottom: 1px solid #dfe3eb;
}
::v-deep(.el-select.bm-sku-spec__select .el-input__inner) {
  width: 235px;
  box-sizing: border-box;
}

.bm-sku-spec__methods:not(.sku-methods) article > .bm-sku-spec__method-content:first-child .el-radio-group {
  display: block;
  width: 100%;
}

.bm-sku-spec__methods:not(.sku-methods) article > .bm-sku-spec__method-content:first-child .el-radio {
  display: block;
  width: 100%;
  margin: 0 0 10px;
}

.bm-sku-spec__filter > footer {
  justify-content: flex-start;
}

.price-methods article {
  display: block;
  padding: 0;
}

.price-method {
  position: relative;
  display: flex;
  align-items: flex-start;
  padding: 12px 16px;
  border: 0;
  border-bottom: 1px solid #e1e4eb;
  border-radius: 0;
  background: #fff;
  transition: background 0.2s;
}

.price-method:hover {
  background: #fafbfd;
}

.price-method.active {
  /* background: #fffdf7; */
  box-shadow: none;
}

.price-method.disabled {
  cursor: not-allowed;
  opacity: 0.52;
}

.price-method-title {
  flex: 0 0 150px;
  min-height: 32px;
  display: flex;
  align-items: center;
  padding: 0 12px 0 0;
}

.price-method-title .el-radio {
  display: block;
  width: 100%;
  margin: 0;
  line-height: 24px;
}

.price-method-title .el-radio__label {
  color: #172b4d;
  font-weight: 600;
}

.price-method-fields {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 10px;
  margin: 0;
  padding: 0 0 2px;
  border: 0;
  background: transparent;
}


.price-method-fields .el-radio-group {
  display: flex;
  gap: 12px;
}

.price-method-fields .el-radio,
.price-method-fields .el-radio__label {
  font-size: 12px;
}

.price-method-fields .el-input {
  width: 160px;
}


.price-method-fields .bm-sku-spec__match {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
}

.price-method-fields .bm-sku-spec__match button {
  border: 0;
  color: #f56c6c;
  background: transparent;
  cursor: pointer;
}

.price-method-fields > button {
  border: 1px solid #c8d2e3;
  border-radius: 3px;
  padding: 6px 10px;
  color: #245a9c;
  background: #fff;
  cursor: pointer;
}

@media (max-width: 700px) {
  .price-method {
    display: block;
  }

  .price-method-title {
    width: 100%;
    padding: 0;
  }

  .price-method-fields {
    margin-top: 8px;
  }
}

@media (max-width: 520px) {
.price-method-fields .el-radio-group {
    flex-wrap: nowrap;
  }
}
</style>